<script lang="ts">
	import phoneCodes from '$lib/components/Contact/phoneCodes.json';
	import Success from '$lib/components/Global/Success.svelte';
	import __ from '$lib/stores/TranslationStore';
	import axios from 'axios';
	import { createEventDispatcher } from 'svelte';
	import Cta from './Cta.svelte';
	import SegmentedInput from './SegmentedInput.svelte';

	const dispatch = createEventDispatcher();
	export let referral: string;
	export let successText: string;
	export let gaEvent: string;

	interface Form {
		contact_language: string;
		contact_hours: string;
		name: string;
		email: string;
		phone: string;
		message: string;
		project: string;
		project_phase: string;
		expected_value: string;
		earnings: string;
		emkt: boolean;
		gdpr: boolean;
	}
	interface Verification {
		id: string;
		sms_code: string;
	}

	let code;
	let success = false;
	let isVerification = false;
	let filled = false;
	let canSubmit = true;
	let canSubmitVerification = true;
	let validationErrors: Form | null;
	let validationVerificationErrors: Verification | null;
	let form: Form = {
		contact_language: 'PT',
		contact_hours: '',
		name: '',
		email: '',
		phone: '',
		message: '',
		project: 'Aquisição de imóvel',
		project_phase: 'Consulta e simulação de ofertas',
		expected_value: '',
		earnings: '',
		emkt: false,
		gdpr: false
	};
	const resetForm = () => {
		form = {
			contact_language: 'PT',
			contact_hours: '',
			name: '',
			email: '',
			phone: '',
			message: '',
			project: 'Aquisição de imóvel',
			project_phase: 'Consulta e simulação de ofertas',
			expected_value: '',
			earnings: '',
			emkt: false,
			gdpr: false
		};
		verification = {
			id: '',
			sms_code: ''
		};
		canSubmit = true;
		canSubmitVerification = true;
	};
	let verification: Verification = {
		id: '',
		sms_code: ''
	};

	$: checkFilled(form);
	$: formatNumbers(form);

	const formatNumbers = (form: Form) => {
		form.expected_value = Number(form.expected_value.replace(/\D/g, '')).toLocaleString();
		form.earnings = Number(form.earnings.replace(/\D/g, '')).toLocaleString();
	};

	const checkFilled = (form: Form) => {
		let validation = {
			all:
				form.contact_language.length &&
				form.contact_hours.length &&
				form.name.length &&
				form.email.length &&
				form.phone.length &&
				form.gdpr,
			contact_request: form.project.length,
			contact_page: form.message.length,
			insurance_page: form.message.length,
			mortgage_page: form.expected_value,
			personal_credit_page:
				form.contact_language.length &&
				form.contact_hours.length &&
				form.project.length &&
				form.expected_value
		};
		if (validation.all && validation[referral]) {
			return (filled = true);
		}
		return (filled = false);
	};

	const getFlagEmoji = (countryCode: string) => {
		const codePoints = countryCode
			.toUpperCase()
			.split('')
			.map((char: string) => 127397 + char.charCodeAt());
		return String.fromCodePoint(...codePoints);
	};

	const submitForm = async (e: object) => {
		canSubmit = false;
		let data = Object.fromEntries(new FormData(e.target));
		let response = await axios
			.post('/api/crm/leads/contact', JSON.stringify(data))
			.then((response) => response.data)
			.then((response) => {
				if (response.status == 422) {
					canSubmit = true;
					isVerification = false;
					validationErrors = response.data?.data?.errors;
				} else if (response.status != 200) {
					canSubmit = true;
					console.log(response);
				}
				return response;
			})
			.catch((error) => {
				canSubmit = true;
				console.log(error);
			});
		if (response?.success) {
            success = true;
			isVerification = true;
			validationErrors = null;
			validationVerificationErrors = null;
			resetForm();
			verification.id = response?.data?.data?.guid;
			//window.gtag('event', 'Submit', { event_category: gaEvent });

            if (window?.gtag) window?.gtag('event', 'Submit', { event_category: gaEvent });

			window.dataLayer.push({
				email: form.email,
				phone: form.phone
			});
		}
	};
	const submitVerification = async (e: object) => {
		canSubmitVerification = false;
		let response = await axios
			.post('/api/crm/leads/' + verification.id + '/verify/' + code)
			.then((response) => response.data)
			.then((response) => {
				if (response.status == 400) {
					validationVerificationErrors = response?.data?.data;
					canSubmitVerification = true;
					// validationErrors = JSON.parse(response.data);
				}
				if (response.success) {
					isVerification = false;
				}
				return response;
			})
			.catch((error) => {
				canSubmitVerification = true;
				console.log(error);
			});
		if (response?.success) {
			success = true;
			isVerification = false;
			validationVerificationErrors = null;
			resetForm();
			setTimeout(() => {
				success = false;
				dispatch('success');
			}, 5000);
		}
	};
	// resetForm();
</script>

{#if isVerification == false || validationErrors != null}
	<form method="POST" on:submit|preventDefault={submitForm} class="mt-4" id="contacto">
		<div class="md:flex md:gap-12">
			<div class="group relative z-0 mb-5 w-full">
				<select
					name="contact_language"
					id="contact_language"
					bind:value={form.contact_language}
					class="peer block w-full border-0 border-b border-dark-2 bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				>
					<option value="PT">{$__('Português')}</option>
					<option value="EN">{$__('Inglês')}</option>
					<option value="FR">{$__('Francês')}</option>
					<option value="IT">{$__('Italiano')}</option>
					<option value="ES">{$__('Espanhol')}</option>
				</select>
				<label
					for="contact_language"
					class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-lg leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary"
					>{$__('Idioma de contacto')}</label
				>
				<span class="text-red-500">{validationErrors?.contact_language ?? ''}</span>
			</div>
			<div class="group relative z-0 mb-5 w-full">
				<select
					name="contact_hours"
					id="contact_hours"
					bind:value={form.contact_hours}
					class="peer block w-full border-0 border-b border-dark-2 bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				>
					<option value="">{$__('Selecione um horário')}</option>
					<option value="9-11">09h00 as 11h00</option>
					<option value="11-13">11h00 as 13h00</option>
					<option value="13-15">13h00 as 15h00</option>
					<option value="15-17">15h00 as 17h00</option>
					<option value="17-19">17h00 as 19h00</option>
				</select>
				<label
					for="contact_hours"
					class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-lg leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary"
					>{$__('Horário de contacto')}</label
				>
				<span class="text-red-500">{validationErrors?.contact_hours ?? ''}</span>
			</div>
		</div>
		<div class="group relative z-0 mb-10 mt-4 w-full">
			<input
				type="text"
				name="name"
				id="name"
				bind:value={form.name}
				class="peer block w-full appearance-none border-0 border-b border-dark bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
				placeholder=" "
			/>
			<label
				for="name"
				class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-xl leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary"
				>{$__('Nome')}</label
			>
			<span class="text-red-500">{$__(validationErrors?.name ?? '')}</span>
		</div>
		<div class="group relative z-0 my-10 w-full">
			<input
				type="text"
				name="email"
				id="email"
				bind:value={form.email}
				class="peer block w-full appearance-none border-0 border-b border-dark bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
				placeholder=" "
			/>
			<label
				for="email"
				class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-xl leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary"
				>{$__('E-mail')}</label
			>
			<span class="text-red-500">{$__(validationErrors?.email ?? '')}</span>
		</div>
		<div class="group relative z-0 my-10 w-full">
			<div class="flex">
				<select
					name="prefix"
					id="prefix"
					class="peer block border-0 border-b border-r border-dark-2 bg-transparent px-0 pb-1 pr-3 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				>
					{#each phoneCodes as phoneCode}
						<option value={phoneCode.dial_code}>
							{getFlagEmoji(phoneCode.code)}
							{phoneCode.dial_code}
						</option>
					{/each}
				</select>
				<input
					type="text"
					inputmode="numeric"
					name="phone"
					bind:value={form.phone}
					on:keyup={(e) => (e.target.value = e.target.value.replace(/[^0-9+]/g, ''))}
					id="phone"
					pattern="[0-9]+"
					class="peer block w-full appearance-none border-0 border-b border-dark bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				/>
			</div>
			<label
				for="phone"
				class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-xl leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary"
				>{$__('Telemóvel')}</label
			>
			<span class="text-red-500">{$__(validationErrors?.phone ?? '')}</span>
		</div>
		{#if referral === 'contact_page' || referral === 'insurance_page'}
			<div class="group relative z-0 my-10 w-full">
				<textarea
					name="message"
					id="message"
					bind:value={form.message}
					class="peer block w-full appearance-none border-0 border-b border-dark bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				/>
				<label
					for="message"
					class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-xl leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary"
					>{$__('Mensagem')}</label
				>
				<span class="text-red-500">{validationErrors?.message ?? ''}</span>
			</div>
		{/if}
		{#if referral === 'contact_request' || referral === 'personal_credit_page'}
			<div class="group relative z-0 mb-10 w-full">
				<select
					name="project"
					id="project"
					bind:value={form.project}
					class="peer block w-full border-0 border-b border-dark-2 bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				>
					<option value="Aquisição de imóvel">{$__('Aquisição de imóvel')}</option>
					<option value="Transferência crédito habitação"
						>{$__('Transferência crédito habitação')}</option
					>
					<option value="Construção/Obras">{$__('Construção/Obras')}</option>
					<option value="Automóvel">{$__('Automóvel')}</option>
					<option value="Consolidação de créditos">{$__('Consolidação de créditos')}</option>
					<option value="Crédito pessoal">{$__('Crédito pessoal')}</option>
					<option value="Seguros">{$__('Seguros')}</option>
					<option value="Outros">{$__('Outros')}</option>
				</select>
				<label
					for="project"
					class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-lg leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary"
					>{$__('Projeto')}</label
				>
				<span class="text-red-500">{validationErrors?.project ?? ''}</span>
			</div>
		{/if}
		{#if referral === 'personal_credit_page'}
			<div class="group relative z-0 mb-10 w-full">
				<select
					name="project_phase"
					id="project_phase"
					bind:value={form.project_phase}
					class="peer block w-full border-0 border-b border-dark-2 bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				>
					<option value="Consulta e simulação de ofertas"
						>{$__('Consulta e simulação de ofertas')}</option
					>
					<option value="Enquadramento e capacidade financeira"
						>{$__('Enquadramento e capacidade financeira')}</option
					>
					<option value="Pedido de viabilidade e aprovação"
						>{$__('Pedido de viabilidade e aprovação')}</option
					>
					<option value="Urgente sequência de processo de crédito"
						>{$__('Urgente sequência de processo de crédito')}</option
					>
					<option value="Outros">{$__('Outros')}</option>
				</select>
				<label
					for="project_phase"
					class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-lg leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary"
					>{$__('Fase do projeto')}</label
				>
				<span class="text-red-500">{validationErrors?.project_phase ?? ''}</span>
			</div>
		{/if}
		{#if referral === 'mortgage_page' || referral === 'personal_credit_page'}
			<div class="group relative z-0 mb-10 mt-4 w-full">
				<input
					type="text"
					inputmode="numeric"
					name="expected_value"
					id="expected_value"
					bind:value={form.expected_value}
					class="peer block w-full appearance-none border-0 border-b border-dark-2 bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				/>
				<span
					class="text-slate-300 absolute bottom-2 right-0 z-10 h-full w-8 items-center justify-center border-l border-dark-2 bg-transparent px-3 py-3 text-center text-xl font-normal leading-snug text-dark-2"
				>
					€
				</span>
				<label
					for="expected_value"
					class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-sm leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary lg:text-xl"
					>{$__('Valor expectável de financiamento')}</label
				>
				<span class="text-red-500">{validationErrors?.expected_value ?? ''}</span>
			</div>
			<div class="group relative z-0 mb-10 mt-4 w-full">
				<input
					type="text"
					name="earnings"
					id="earnings"
					inputmode="numeric"
					bind:value={form.earnings}
					class="peer block w-full appearance-none border-0 border-b border-dark-2 bg-transparent px-0 pb-1 pt-2.5 text-xl text-dark focus:border-secondary focus:outline-none focus:ring-0"
					placeholder=" "
				/>
				<span
					class="text-slate-300 absolute bottom-2 right-0 z-10 h-full w-8 items-center justify-center border-l border-dark-2 bg-transparent px-3 py-3 text-center text-xl font-normal leading-snug text-dark-2"
				>
					€
				</span>
				<label
					for="earnings"
					class="absolute top-1 -z-10 origin-[0] -translate-y-6 scale-75 transform text-[11px] leading-6 text-dark duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:left-0 peer-focus:-translate-y-6 peer-focus:scale-75 peer-focus:font-medium peer-focus:text-secondary lg:text-xl"
					>{$__('Rendimento líquido mensal do agregado')}</label
				>
				<span class="text-red-500">{validationErrors?.earnings ?? ''}</span>
			</div>
		{/if}
		<div class="items-top mb-4 flex">
			<div class="basis-1">
				<input
					id="gdpr"
					type="checkbox"
					name="gdpr"
					bind:checked={form.gdpr}
					class="w-[13px] bg-gray-100 text-secondary"
				/>
			</div>
			<label for="gdpr" class="-mt-2 ml-4 text-xs font-medium text-dark"
				>{@html $__(
					'Declaro que aceito a <a class="text-primary font-semibold" href="/politica-de-protecao-de-dados">Política de proteção de dados</a> e os <a class="text-primary font-semibold" href="/termos-e-condicoes">Termos e Condições</a> e que os meus dados pessoais sejam processados para aconselhamento em formas de poupança junto dos parceiros da Financefy SA.'
				)}</label
			>
		</div>
		<span class="text-red-500">{validationErrors?.gdpr ?? ''}</span>
		<div class="items-top mb-4 flex">
			<div class="basis-1">
				<input
					id="emkt"
					type="checkbox"
					name="emkt"
					value="1"
					bind:checked={form.emkt}
					class="w-[13px] bg-gray-100 text-secondary"
				/>
			</div>
			<label for="emkt" class="-mt-2 ml-4 text-xs font-medium text-dark"
				>{$__(
					'Autorizo a Financefy SA a utilizar os meus dados pessoais para que possa receber conteúdos informativos relevantes, sabendo que posso alterar esta opção a qualquer momento.'
				)}</label
			>
		</div>
		<span class="text-red-500">{validationErrors?.emkt ?? ''}</span>

		<input type="hidden" name="referral" value={referral} />
		<input type="hidden" name="domain" value="POUPANCAMINUTO" />
		<Cta
			type="button"
			class="mt-10 inline-block px-10 py-4 text-center font-semibold leading-nav-button text-white md:w-full md:border-0 lg:mt-12 2xl:text-nav-button {filled
				? 'bg-primary'
				: 'bg-contact-btn'}"
			props={{
				disabled: !filled || !canSubmit,
				type: 'submit'
			}}
		>
			{$__('Enviar')}
		</Cta>
	</form>
{:else if isVerification == false && success == false}
	<form method="POST" on:submit|preventDefault={submitVerification} class="mt-4">
		<div class="text-center md:flex md:gap-12">
			<div class="group relative z-0 mb-10 mt-4 w-full">
				<SegmentedInput
					label={$__('Confirme o código recebido por SMS')}
					styleClass={'top-4'}
					length={4}
					bind:code
				/>
				<span class="text-red-500">{validationVerificationErrors?.message ?? ''}</span>
				<input type="hidden" name="id" value={verification.id} />
				<input type="hidden" name="sms_code" value={code} />
				<button
					type="submit"
					class="mt-10 inline-block px-10 py-4 text-center font-semibold leading-nav-button text-white md:w-full md:border-0 lg:mt-12 2xl:text-nav-button {canSubmitVerification
						? 'bg-primary'
						: 'bg-contact-btn'}"
				>
					{$__('Validar')}</button
				>
			</div>
		</div>
	</form>
{/if}
{#if success && isVerification == true}
	<Success {successText} />
{/if}

<style>
	select {
		background: url($lib/assets/images/icons/select-arrow.svg) no-repeat 95% 50%;
		-moz-appearance: none;
		-webkit-appearance: none;
		appearance: none;
		border-radius: 0;
	}
	input[type='checkbox'] {
		transform: scale(1.3);
		margin-left: 2px;
	}
</style>
